import { render, staticRenderFns } from "./AddToCart.vue?vue&type=template&id=4ca874c8&scoped=true"
import script from "./AddToCart.vue?vue&type=script&lang=js"
export * from "./AddToCart.vue?vue&type=script&lang=js"
import style0 from "./AddToCart.vue?vue&type=style&index=0&id=4ca874c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca874c8",
  null
  
)

export default component.exports